import { createLogger } from 'vuex';

export default createLogger({
    collapsed: false,
});
